import { useSelector } from 'react-redux';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './responseTime.module.scss';

export default function ResponseTimeContent() {
  const { responseTime } = useSelector((state) => state.DashboardSlice);
  const {
    mdn = '-',
    max = '-',
    min = '-',
    company_median_time,
    percentage_status,
    icon,
    variation,
  } = responseTime;

  return (
    <>
      <PerformanceCard.Summary
        value={mdn}
        tendency={variation}
        percentageStatus={percentage_status}
        icon={icon}
      />

      <Box className={styles.separator} />

      <PerformanceCard.Content>
        <Box className={styles.responseTimeValues}>
          {company_median_time ? (
            <Box className={styles.item}>
              <Text className={styles.itemLabel}>
                {Trans(translations, 'CompanyAverageResponseTime')}
              </Text>
              <Text className={styles.itemValue}>{company_median_time}</Text>
            </Box>
          ) : (
            <>
              <Box className={styles.item}>
                <Text className={styles.itemLabel}>
                  {Trans(translations, 'MaximumPerAgentAcrossTheCompany')}
                </Text>
                <Text className={`${styles.itemValue} ${styles.itemValueMax}`}>
                  {max}
                </Text>
              </Box>
              <Box className={styles.item}>
                <Text className={styles.itemLabel}>
                  {Trans(translations, 'MinimumPerAgentAcrossTheCompany')}
                </Text>
                <Text className={`${styles.itemValue} ${styles.itemValueMin}`}>
                  {min}
                </Text>
              </Box>
            </>
          )}
        </Box>
      </PerformanceCard.Content>
    </>
  );
}
